import {
  CREATE_ASSESSMENT_CONFIGURATION_REQUEST,
  CREATING_ASSESSMENT_CONFIGURATION_FAILED,
  CREATING_ASSESSMENT_CONFIGURATION_SUCCEEDED,
  DELETE_ASSESSMENT_CONFIGURATION_REQUEST,
  DELETING_ASSESSMENT_CONFIGURATION_FAILED,
  DELETING_ASSESSMENT_CONFIGURATION_SUCCEEDED,
  DISCARD_ASSESSMENT_CONFIGURATION_DRAFT_REQUEST,
  DISCARDING_ASSESSMENT_CONFIGURATION_DRAFT_FAILED,
  DISCARDING_ASSESSMENT_CONFIGURATION_DRAFT_SUCCEEDED,
  FETCH_ASSESSMENT_CONFIGURATION_REQUEST,
  FETCH_ASSESSMENT_CONFIGURATIONS_REQUEST,
  FETCHING_ASSESSMENT_CONFIGURATION_FAILED,
  FETCHING_ASSESSMENT_CONFIGURATION_SUCCEEDED,
  FETCHING_ASSESSMENT_CONFIGURATIONS_FAILED,
  FETCHING_ASSESSMENT_CONFIGURATIONS_SUCCEEDED,
  INVALIDATE_ASSESSMENT_CONFIGURATION_CREATION_STATE,
  INVALIDATE_ASSESSMENT_CONFIGURATION_DELETION_STATE,
  INVALIDATE_ASSESSMENT_CONFIGURATION_EDIT_STATE,
  INVALIDATE_ASSESSMENT_CONFIGURATION_UPDATE_STATE,
  INVALIDATE_ASSESSMENT_CONFIGURATIONS,
  INVALIDATE_PUBLISH_ASSESSMENT_CONFIGURATION,
  PUBLISH_ASSESSMENT_CONFIGURATION_REQUEST,
  PUBLISHING_ASSESSMENT_CONFIGURATION_FAILED,
  PUBLISHING_ASSESSMENT_CONFIGURATION_SUCCEEDED,
  UPDATE_ASSESSMENT_CONFIGURATION_PROPERTY,
  UPDATE_ASSESSMENT_CONFIGURATION_REQUEST,
  UPDATING_ASSESSMENT_CONFIGURATION_FAILED,
  UPDATING_ASSESSMENT_CONFIGURATION_SUCCEEDED,
} from "src/redux/actions/actionTypes";
import _ from "lodash";
import {
  AssessmentConfiguration,
  FetchAssessmentConfigurationResponse,
  FetchAssessmentConfigurationErrorResponse,
  UpdateAssessmentConfigurationRequest,
  UpdateAssessmentConfigurationResponse,
  FetchAssessmentConfigurationsResponse,
  FetchAssessmentConfigurationsErrorResponse,
  UpdateAssessmentConfigurationErrorResponse,
  UpdateAssessmentConfigurationProperty,
  CreateAssessmentConfigurationRequest,
  CreateAssessmentConfigurationResponse,
} from "src/types/coaching/assessmentConfiguration";

interface ScorecardsState {
  loading: boolean;
  loaded: boolean;
  items: AssessmentConfiguration[];
  creation: AssessmentConfigurationCreation | null;
  edit: AssessmentConfigurationEditState | null;
  scorecard: {
    [key: string]: AssessmentConfiguration;
  },
  update: {
    [key: string]: AssessmentConfigurationUpdateState;
  };
  deletion: {
    [key: string]: AssessmentConfigurationDeletionState;
  };
  publish: {
    [key: string]: AssessmentConfigurationPublishState;
  }
  error: any;
}

interface AssessmentConfigurationEditState {
  item: AssessmentConfiguration | null;
  errors: any; //TODO -> check if we need a specific  arr of types here
}


interface AssessmentConfigurationPublishState {
  publishing: boolean;
  published: boolean;
  error: any;
}

interface AssessmentConfigurationCreation {
  creating: boolean;
  created: boolean;
  item: AssessmentConfiguration | null;
  error: any;
}

interface AssessmentConfigurationUpdateState {
  id: string;
  updating: boolean;
  updated: boolean;
  item: AssessmentConfiguration | null;
  error: any;
}

interface AssessmentConfigurationDeletionState {
  id: string;
  deleting: boolean;
  deleted: boolean;
  error: any;
}

const initialScorecardsState: ScorecardsState = {
  loading: false,
  loaded: false,
  items: [],
  creation: null,
  edit: null,
  scorecard: {},
  update: {},
  deletion: {},
  publish: {},
  error: null,
  
};

const initialCourseUpdateState: AssessmentConfigurationUpdateState = {
  id: "",
  updating: false,
  updated: false,
  item: null,
  error: null,
};

export function scorecardsReducer(state = initialScorecardsState, action: any) {
  switch (action.type) {

    case FETCH_ASSESSMENT_CONFIGURATION_REQUEST: {
      const id = action.payload as string;
      const scorecardState = state.scorecard[id] || {
        loading: true,
        loaded: false,
        item: null,
        error: null,
      };
    
      return {
        ...state,
        scorecard: {
          ...state.scorecard,
          [id]: {
            ...scorecardState,
            loading: true,
            loaded: false,
            error: null,
          }, 
        }
      };
    }

    case FETCHING_ASSESSMENT_CONFIGURATION_SUCCEEDED: {
      const { response } = action.payload as FetchAssessmentConfigurationResponse;
      
      if(!response || !response.id) {
        return state;
      }

      const scorecardState = state.scorecard[response.id];
      if(!scorecardState) {
        return scorecardState;
      }

      return {
        ...state,
        scorecard: {
          ...state.scorecard,
          [response.id]: {
            ...scorecardState,
            loading: false,
            loaded: true,
            item: response,
            error: null,
          },
        },
        edit: {
          ...(state.edit || {
            item: null,
            errors: [],
          }),
          item: response,
          errors: [],
        },  
      };      
    }

    case FETCHING_ASSESSMENT_CONFIGURATION_FAILED: {
      const {id, error } = action.payload as FetchAssessmentConfigurationErrorResponse;

      const scorecardState = state.scorecard[id];
      if(!scorecardState) {
        return scorecardState;
      }


      return {
        ...state,
        scorecard: {
          ...state.scorecard,
          [id]: {
            ...scorecardState,
            loading: false,
            loaded: false,
            error: error,
          },
        },  
      };
    }   

    case FETCH_ASSESSMENT_CONFIGURATIONS_REQUEST: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    }

    case FETCHING_ASSESSMENT_CONFIGURATIONS_SUCCEEDED: {
      const { response } =
        action.payload as FetchAssessmentConfigurationsResponse;

      return {
        ...state,
        loading: false,
        loaded: true,
        items: response,
        error: null,
      };
    }

    case FETCHING_ASSESSMENT_CONFIGURATIONS_FAILED: {
      const { error } =
        action.payload as FetchAssessmentConfigurationsErrorResponse;

      return {
        ...state,
        loading: false,
        loaded: false,
        error: error,
      };
    }

    case CREATE_ASSESSMENT_CONFIGURATION_REQUEST: {
      return {
        ...state,
        creation: {
          creating: true,
          created: false,
          item: null,
          error: null,
        },
      };
    }

    case CREATING_ASSESSMENT_CONFIGURATION_SUCCEEDED: {
      const {id, response } = action.payload as CreateAssessmentConfigurationResponse;
      const records = [...state.items, response];

      const scorecardState = state.scorecard[id] || {
        loading: false,
        loaded: false,
        item: null,
        error: null,
      };

      return {
        ...state,
        creation: {
          creating: false,
          created: true,
          item: response,
          error: null,
        },
        items: records,
        scorecard: {
          ...state.scorecard,
          [id]: {
            ...scorecardState,
            item: response,
          },
        },
        edit: {
          ...(state.edit || {
            item: null,
            errors: [],
          }),
          item: response,
          errors: [],
        },
      };
    }

    case CREATING_ASSESSMENT_CONFIGURATION_FAILED: {
      return {
        ...state,
        creation: {
          creating: false,
          created: false,
          item: null,
          error: action.payload.error,
        },
      };
    }

    case INVALIDATE_ASSESSMENT_CONFIGURATION_CREATION_STATE: {
      return {
        ...state,
        creation: null,
      };
    }


    case DISCARD_ASSESSMENT_CONFIGURATION_DRAFT_REQUEST:
    case UPDATE_ASSESSMENT_CONFIGURATION_REQUEST: {
      const { id } = action.payload as UpdateAssessmentConfigurationRequest;
      let updateState = state.update[id] || initialCourseUpdateState;
      updateState = {
        ...updateState,
        id,
        updating: true,
        updated: false,
        item: null,
        error: null,
      };

      return {
        ...state,
        update: {
          ...state.update,
          [id]: updateState,
        },
      };
    }

    case DISCARDING_ASSESSMENT_CONFIGURATION_DRAFT_SUCCEEDED:
    case UPDATING_ASSESSMENT_CONFIGURATION_SUCCEEDED: {
      const { response } =
        action.payload as UpdateAssessmentConfigurationResponse;
      const id = response.id;
      if (!id) {
        return state;
      }

      const updateState = state.update[id];
      if (!updateState) {
        return state;
      }

      const scorecardState = state.scorecard[id];

      const items = state.items.map((item) => {
        if (item.id === id) {
          return response;
        }

        return item;
      });

      return {
        ...state,
        items: items,
        update: {
          ...state.update,
          [id]: {
            ...updateState,
            updating: false,
            updated: true,
            item: response,
            error: null,
          },
        },
        scorecard: {
          ...state.scorecard,
          [id]: {
            ...scorecardState,
            item: response,
          },
        },
        edit: {
          ...(state.edit || {
            item: null,
            errors: [],
          }),
          item: response,
          errors: [],
        },
      };
    }

    case DISCARDING_ASSESSMENT_CONFIGURATION_DRAFT_FAILED:
    case UPDATING_ASSESSMENT_CONFIGURATION_FAILED: {
      const { id, error } =
        action.payload as UpdateAssessmentConfigurationErrorResponse;
      return {
        ...state,
        update: {
          ...state.update,
          [id]: {
            updating: false,
            updated: false,
            item: null,
            error,
          },
        },
      };
    }

    case INVALIDATE_ASSESSMENT_CONFIGURATION_UPDATE_STATE : {
      return {
        ...state,
        update: {},
      };
    }

    case DELETE_ASSESSMENT_CONFIGURATION_REQUEST: {
      const { id } = action.payload;
      return {
        ...state,
        deletion: {
          ...state.deletion,
          [id]: {
            deleting: true,
            deleted: false,
            error: null,
          },
        },
      };
    }

    case DELETING_ASSESSMENT_CONFIGURATION_SUCCEEDED: {
      const { id } = action.payload;
      const deletionState = state.deletion[id];
      if (!deletionState) {
        return state;
      }

      const items = state.items.filter((item) => {
        return item.id !== id;
      });

      return {
        ...state,
        items: items,
        deletion: {
          ...state.deletion,
          [id]: {
            deleting: false,
            deleted: true,
            error: null,
          },
        },
      };
    }

    case DELETING_ASSESSMENT_CONFIGURATION_FAILED: {
      const { id, error } = action.payload;
      return {
        ...state,
        deletion: {
          ...state.deletion,
          [id]: {
            deleting: false,
            deleted: false,
            error,
          },
        },
      };
    }

    case INVALIDATE_ASSESSMENT_CONFIGURATION_DELETION_STATE: {
      return {
        ...state,
        deletion: {}
      };
    }



    case PUBLISH_ASSESSMENT_CONFIGURATION_REQUEST: {
      const { id } = action.payload;
      return {
        ...state,
        publish: {
          ...state.publish,
          [id]: {
            publishing: true,
            published: false,
            error: null,
          },
        },
      };
    }

    case PUBLISHING_ASSESSMENT_CONFIGURATION_SUCCEEDED: {
      const { id, response } = action.payload;

      if (!id) {
        return state;
      }

      const publishState = state.publish[id];
      if (!publishState) {
        return state;
      }
      
      const scorecardState = state.scorecard[id];

      let editState = state.edit;
      if (editState && editState.item?.id === id) {
        const {
          hasChanges,
          published,
          defaultConfiguration,
          systemDefined,
          modifiedDate,
        } = response;
    
        editState = {
          ...editState,
          item: {
            ...editState.item,
            hasChanges,
            published,
            defaultConfiguration,
            systemDefined,
            modifiedDate,
          },
          errors: [],
        };
      }

      const items = state.items.map((item) => {
        if (item.id === id) {
          return response;
        }
      
        if (item.defaultConfiguration) {
          return {
            ...item,
            defaultConfiguration: false,
          };
        }
      
        return item;
      });

      return {
        ...state,
        items: items,
        publish: {
          ...state.publish,
          [id]: {
            ...publishState,
            publishing: false,
            published: true,
            error: null,
          },
        },
        scorecard: {
          ...state.scorecard,
          [id]: {
            ...scorecardState,
            item: response,
          },
        },
        edit: editState,
      };
    }

    case PUBLISHING_ASSESSMENT_CONFIGURATION_FAILED: {
      const { id, error } = action.payload;
      return {
        ...state,
        publish: {
          ...state.publish,
          [id]: {
            publishing: false,
            published: false,
            error,
          },
        },
      };
    }

    case INVALIDATE_PUBLISH_ASSESSMENT_CONFIGURATION: {
      return {
        ...state,
        publish: null,
      };
    }

    case UPDATE_ASSESSMENT_CONFIGURATION_PROPERTY: {
      const { id, property, value } = action.payload as UpdateAssessmentConfigurationProperty;

      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (!editState.item || editState.item.id !== id) {
        return state;
      }

      const updatedItem = _.cloneDeep(editState.item);
      _.set(updatedItem, property, value);

      return {
        ...state,
        edit: {
          ...editState,
          item: updatedItem
        },
      };
    }
    

    case INVALIDATE_ASSESSMENT_CONFIGURATION_EDIT_STATE: {
      return {
        ...state,
        edit: null,
      };
    }

    case INVALIDATE_ASSESSMENT_CONFIGURATIONS:
      return {
        ...state,
        items: [],
        loading: false,
        loaded: false,
        error: null,
      };

    default:
      return state;
  }
}
